import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import {
  downloadQuestionsAnswerHeader,
  downloadQuestionsAnswerHeaderExcel,
} from "../components/HeaderAttribute";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import * as XLSX from "sheetjs-style";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import DownloadSubmissionPopup from "../popup-containers/DownloadSubmissionPopup";
import toast from "react-hot-toast";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useUserCapability } from "../components/ConstantReducerProvider";

const DownloadQuestionsandAnswersAnalyst = () => {
  const { userProfileState, dispatch } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const roleId =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].MstRoleId
      : null;
  // use state for auto dropdown
  const [partner, setPartner] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [partnerError, setPartnerError] = useState("");
  const [bindPartnerDatas, setPartnerDatas] = useState([]);
  const [downloadSubmissionGridData, setDownloadSubmissionGridData] = useState(
    []
  );
  const [downloadSubmissionGridDataChild, setDownloadSubmissionGridDataChild] =
    useState([]);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [downloadSubmission, setDownloadSubmission] = useState("");

  // use effect for auto dropdown data
  useEffect(() => {
    const BindCompanyAndChainPartnerDropdown = async () => {
      const bindReferredBydatadrp = await BindAPI("PartnerAPI/BindPartner");
      const filteredData = bindReferredBydatadrp.data.Table;
      const filteredWithInActivatedByNull = filteredData.filter(
        (item) => item.Status === "Active"
      );

      const filteredWithTypeC = filteredWithInActivatedByNull.filter(
        (item) => item.Type === "VCP"
      );
      bindCompanyAndChainPartnerData(filteredWithTypeC);
    };
    BindCompanyAndChainPartnerDropdown();
  }, []);

  const bindCompanyAndChainPartnerData = async (resultdata) => {
    try {
      if (resultdata.length > 0) {
        const CompanyAndChainPartnerDD = resultdata.map((m) => ({
          value: m.MstPartnerId,
          label: m.PartnerName,
        }));
        setPartnerDatas(CompanyAndChainPartnerDD);
      } else {
        setPartnerDatas([]);
      }
    } catch (error) {
      console.error("Error fetching CompanyAndChainPartner data:", error);
    }
  };

  // gridData function for grid data
  const gridData = async (value) => {
    
    try {
      const data = {
        partner: value.value,
      };
      const response = await BindPostAPI(
        data,
        "DownloadSubmissionAPI/BindDownloadSubmission"
      );
      if (response.data.Table.length != 0) {
        setDownloadSubmissionGridData(response.data.Table);
        setDownloadSubmissionGridDataChild(response.data.Table1);
      } else {
        setDownloadSubmissionGridData([]);
        setDownloadSubmissionGridDataChild([]);
      }
    } catch (error) {
      console.error("Error fetching download submission grid data:", error);
    }
  };

  const handle1 = (value) => {
    setSelectedRows(value);
    setCheckBoxStatus(value);
  };

  // Popup functionality
  const handlePopup = (rowIndex, flag) => {
    const selectedRow = downloadSubmissionGridData[rowIndex];
    const TxnAnswerQuestionsId = selectedRow.TxnAnswerQuestionsId;
    const filteredData = downloadSubmissionGridDataChild.filter(
      (item) => item.TxnAnswerQuestionsId === TxnAnswerQuestionsId
    );
    setDownloadSubmission(filteredData);
    setpopUpOpen(true);
  };

  const handleExport = () => {
    
    if (partner == "") {
      setPartnerError(partner ? "" : "Select Partner");
    } else if (selectedRows.length == 0) {
      toast.error("Select Check Box", {
        duration: 3000,
        position: "top-center",
      });
      setTimeout(5000);
    } else {
      const uniqueByTxnAnswerQuestionsId = Object.values(
        downloadSubmissionGridDataChild.reduce((acc, curr) => {
          acc[curr.TxnAnswerQuestionsId] = curr; // Overwrite with the latest entry for each ID
          return acc;
        }, {})
      );
      const filteredData = uniqueByTxnAnswerQuestionsId.filter((_, index) =>
        checkBoxStatus.includes(index)
      );
      const filteredTxnAnswerQuestionsIds = filteredData.map(
        (item) => item.TxnAnswerQuestionsId
      );
      const filteredGridData = downloadSubmissionGridDataChild.filter((item) =>
        filteredTxnAnswerQuestionsIds.includes(item.TxnAnswerQuestionsId)
      );

      exportData(
        downloadQuestionsAnswerHeaderExcel
          .slice(0, -1) // Remove last header
          .map((column) => column.title),
        filteredGridData
      );
    }
  };

  const exportData = (columns, rows) => {
    
    const titleRow = [
      {
        v: "Download Submission",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "000000" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),
    ];
    // Initialize column totals

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ModuleName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicNo,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.QuestionNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Question,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Attachment,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.IndicatedPages,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Comments,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
      ];
    });

    const wsData = [titleRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 30 }, // Branch
      { width: 15 }, // IPC  No
      { width: 30 }, // IPC  No
      { width: 15 }, // IPC  No
      { width: 100 }, // Gender
      { width: 30 }, // IPC  No
      { width: 15 }, // IPC  No
      { width: 100 }, // IPC  No
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${partnerName}.xlsx`);
  };

  const handleDownload = async () => {
    if (partner === "") {
      setPartnerError("Select Partner");
    } else if (selectedRows.length === 0) {
      toast.error("Select Check Box", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      const filteredData = downloadSubmissionGridData.filter((_, index) =>
        checkBoxStatus.includes(index)
      );
      const filteredTxnAnswerQuestionsIds = filteredData.map(
        (item) => item.TxnAnswerQuestionsId
      );
      const filteredGridData = downloadSubmissionGridDataChild.filter((item) =>
        filteredTxnAnswerQuestionsIds.includes(item.TxnAnswerQuestionsId)
      );

      // Group by QuestionNumber
      const groupedByQuestion = filteredGridData.reduce((acc, item) => {
        const key = item.QuestionNumber;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      for (const [questionNumber, items] of Object.entries(groupedByQuestion)) {
        const zip = new JSZip();

        for (const item of items) {
          if (item.AttachedDocument) {
            const fileName = item.AttachedDocument.split("/").pop();

            try {
              const response = await fetch(item.AttachedDocument);
              const blob = await response.blob();
              zip.file(fileName, blob);
            } catch (err) {
              console.error(`Failed to fetch: ${item.AttachedDocument}`, err);
            }
          }
        }

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${partnerName}_Question_${questionNumber}.zip`);
      }
    }
  };

  const downloadAttachment = async (value) => {
    try {
      let attachmentData = convertArrayToJSONString(value);

      const data = {
        attachment: attachmentData,
      };

      const response = await IUDAPI(
        data,
        "DownloadSubmissionAPI/IUDDownloadAttachments",
        {
          responseType: "blob", // must send responseType: 'blob'
        }
      );

      const blob = new Blob([response.data], { type: "application/zip" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "attachments.zip";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading attachments:", error);
    }
  };

  const [companyDetails, setCompanyDetails] = useState([]);

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setCompanyDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };
  return (
    <MainLayout pageName={roleId == 2 ? "3" : "5"}>
      <div>
        <div className=" grid grid-cols-1 gap-4 mb-2 md:grid-cols-3 justify-center">
          <div className="my-1 max-lg:mt-6 mx-2 lg:mx-0">
            <AutoDropDown
              title="Partner"
              classStar="text-red-500"
              options={bindPartnerDatas}
              placeholder="Select"
              name="Supplier"
              selectedOption={partner}
              Class="custom-class"
              tabIndex="1"
              controlFunc={(value) => {
                setPartnerName(value.label);
                setPartner(value);
                gridData(value);
                handle1([]);
              }}
              controlFuncBlur={() => {
                setPartnerError(partner ? "" : "Select Partner");
              }}
            />
            {partnerError && (
              <span className="text-red-500">{partnerError}</span>
            )}
          </div>
        </div>
        <ReportGridPage
          title="Download Submission"
          header={downloadQuestionsAnswerHeader}
          records={downloadSubmissionGridData}
          handleExport={handleExport}
          handleDownload={handleDownload}
          checkBoxStatus={handle1}
          selectedRows={selectedRows}
          handleAction={handlePopup}
        />
      </div>

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Download Submission"
            setpopUpOpen={setpopUpOpen}
            hederDetails={[]}
          />
          <DownloadSubmissionPopup data={downloadSubmission} />
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default DownloadQuestionsandAnswersAnalyst;
